import { createSlice } from '@reduxjs/toolkit';
import { sendResetCode } from '../actions/sendResetCodeAction';

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  data: null,
};

const sendResetCodeSlice = createSlice({
  name: 'sendResetCode',
  initialState,
  reducers: {
    resetSendResetCodeState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendResetCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendResetCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(sendResetCode.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload || 'Failed to send code';
      });
  },
});

export const { resetSendResetCodeState } = sendResetCodeSlice.actions;
export default sendResetCodeSlice.reducer;
